import * as animationData from '@/assets/animations/actionCompleted.json';
import AnimationWrapper from '../AnimationWrapper';
import { AnimationProps } from '../types';

const ActionCompleted = (props: AnimationProps) => {
  const animationProps = { ...props, animationData };
  return <AnimationWrapper {...animationProps} />;
};

export default ActionCompleted;
